export type P6p9RecordType = {
  id: number;
  worksNumber: string;
  title: string;
  forename: string;
  surname: string;
  NINumber: string;
  employerRef: string;
  issuedDate: string;
  effectiveDate: string;
  taxCode: string;
  Wk1M1: boolean;
  p45GrossToDate: number | null;
  p45TaxDeducted: number | null;
  status: string;
  dateAppliedOrCancelled: string;
  data: {
    FormType: string;
    IssueDate: string;
    SequenceNumber: string;
    TaxYearEnd: string;
    xmlns: string;
    EmployerRef: string;
    Name: {
      Title: string;
      Forename: string;
      Surname: string;
    };
    NINO: string;
    WorksNumber: string;
    EffectiveDate: string;
    CodingUpdate: {
      TaxCode: string;
    };
  };
  dataApplied: {
    taxCode: string;
    taxBasis: string;
  };
  subcontractorRefId: string;
  isError: boolean;
  isWarning: boolean;
  message: string | null;
  isUpdate: boolean;
  companyParentId: string;
  author: string | null;
  createdAt: string;
  updatedAt: string;
  subcontractorRef: {
    id: string;
    systemId: string;
    title: string;
    forename: string;
    surname: string;
    DOB: string;
    NINumber: string;
    agencyRef: string;
    paymentModel: string;
    companyParentId: string;
    setting: {
      id: string;
      taxCode: string;
      taxBasis: string;
      p45GrossToDate: number | null;
      p45TaxToDate: number | null;
      companyParentId: string;
      loanTypes: string[];
      expenseClaimRule: string;
      holidayPayBalance: number | null;
      haveOutstandingHolidayPay: boolean;
    };
    status: string;
    errorSubmittingSmartPension: string | null;
    errorUpdatingSmartPension: string | null;
    errorsSubmittingNestPension: string | null;
    erPensionPercentage: number | null;
    eePensionPercentage: number | null;
    erPensionFixedAmount: number | null;
    eePensionFixedAmount: number | null;
  };
  request: {
    id: number;
    dataType: string;
    service: string;
    got: number;
    nItems: number;
    xmlRequest: string;
    xmlResponse: string;
    paymentCompanyId: string;
    status: string;
    message: string;
    companyParentId: string;
    author: null;
    createdAt: string;
    updatedAt: string;
    paymentCompany: {
      isAuthorizedSmartPension: boolean;
      isInPensionMode: boolean;
      isContainPayeOrUmbrella: boolean;
      id: string;
      companyName: string;
      paymentModel: string[];
      companyParentId: string;
      splitSalaryAndBonus: boolean;
    };
  };
};

export enum HMRCDataType {
  P6P9 = 'P6-P9',
  STUDENT_LOAN = 'STUDENT_LOAN',
}
